import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

import { useIntakeEvent } from "../../lib/queries/intakeEvents";

import { VoluntaryEmailGuide } from "./VoluntaryEmailGuide";

type Props = React.ComponentProps<typeof VoluntaryEmailGuide>;

/** Select instructions from the permitted receipt, never from its URL alone. */
export function ReceiptGuide(props: Props) {
  const { context, scope, onContextValidation } = props;
  const { t, i18n } = useTranslation();
  const receipt = useIntakeEvent(scope && !context.emailUpload ? context.receiptId : undefined);
  const available = !!scope && !receipt.isError && !receipt.isPending && !!receipt.data;
  useEffect(() => {
    onContextValidation?.(!!scope && (context.emailUpload || available));
  }, [scope, context.emailUpload, available, onContextValidation]);

  if (
    scope &&
    (context.emailUpload ||
      (available &&
        (receipt.data?.payload?.kind === "voluntary_email" ||
          receipt.data?.payload?.kind === "provider_email")))
  ) {
    return <VoluntaryEmailGuide {...props} />;
  }
  const form = receipt.data?.source_kind === "form_submission";
  return (
    <section aria-label={t("guide.title")} className="min-w-0 space-y-4">
      {!scope ? (
        <p role="status">{t("guide.choose_firm")}</p>
      ) : receipt.isError ? (
        <p role="alert">{t("guide.unavailable")}</p>
      ) : !available ? (
        <p role="status">{t("voluntary_email.loading")}</p>
      ) : (
        <>
          <h3 className="text-lg font-semibold">
            {t(form ? "receipt_guide.form_title" : "receipt_guide.title")}
          </h3>
          <p>{t("receipt_guide.review")}</p>
          {form && (
            <>
              <p>{t("receipt_guide.consent")}</p>
              <Link
                className="focus-visible:ring-brand-500 inline-flex min-h-11 items-center rounded border border-slate-300 px-3 py-2 text-sm focus-visible:ring-2"
                to={`/privacy?lang=${i18n.language.startsWith("en") ? "en" : "fr"}`}
              >
                {t("receipt_guide.notice")}
              </Link>
            </>
          )}
          <p className="text-xs text-slate-500">{t("guide.no_effect")}</p>
        </>
      )}
    </section>
  );
}
